import React from 'react'
import styled from "styled-components";
import LuxWeb3Context from '../../context/LuxWeb3Context';
import { device } from "../../utils";

// ~~~~ STYLING : compact — lives in the header's left pane (where the
// welcome tag sits), outside the scrolling content
const FiltersWrap = styled.div`
    display: inline-flex;
    position: relative;
    align-items: center;

    /* Never reach into the nav buttons on the right — cap the width to the
       viewport minus the nav's claim (menu button + enlighten + padding) */
    max-width: calc(100vw - 150px);

    .filter-panel {
        display: flex;
        padding: 6px 10px 6px;
        align-items: center;
        flex-wrap: wrap;
        max-width: 100%;
    }

    .filter-header {
        text-align: center;
        min-width: 70px;

        @media ${device.sm} {
            min-width: 100px;
        }

        /* Small screens: drop the label, keep the buttons */
        @media (max-width: 430px) {
            display: none;
        }
    }

    .quick-filter-wrap {
        display: flex;
        align-items: center;
        margin-bottom: 0;
        padding-bottom: 0;

        .quick-filter {
            font-size: 12px;
            @media (max-width: 767px) { font-size: 10px; }

            /* Tighter buttons where every px counts */
            @media (max-width: 430px) {
                padding: 5px 10px;
            }

            &#filter-apparel {
                margin-right: 10px;

                @media (max-width: 430px) {
                    margin-right: 6px;
                }
            }
        }
    }
`;



class ShopFilters extends React.Component {
    static contextType = LuxWeb3Context;

    constructor(props) {
        super(props);
        this.handleFilter = this.handleFilter.bind(this);
    }

    // UNDOING? Clicking the active filter unapplies it
    handleFilter(e) {
        let filter = e.target.id.split('filter-')[1];
        if ( e.target.classList.contains('active') ) {
            filter = null;
        }
        this.context.setShopFilter(filter);
    }

    render() {
        const { shopFilter } = this.context;

        return (
        <FiltersWrap>
            <div className="cult-panel filter-panel">
                <div className="filter-header">FILTER</div>
                <ul className="quick-filter-wrap">
                    <li id="filter-apparel" className={`quick-filter cult-button ${shopFilter === 'apparel' ? 'active cult-button-alt-colors':''}`} onClick={this.handleFilter} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') this.handleFilter(e); }} role="button" tabIndex={0}>Apparel{shopFilter === 'apparel' ? ' X':''}</li>
                    <li id="filter-neon" className={`quick-filter cult-button ${shopFilter === 'neon' ? 'active cult-button-alt-colors':''}`} onClick={this.handleFilter} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') this.handleFilter(e); }} role="button" tabIndex={0}>Neon{shopFilter === 'neon' ? ' X':''}</li>
                </ul>
            </div>
        </FiltersWrap>
        )
    }
};

export default ShopFilters;
